import { Dispatch } from "redux";
import { LoginService } from "../services/LoginService";
import { passwordapi } from "../ApiNames";

 export const ResetPasswordSuccess=(passwords:any) =>({
    type: 'RESET_PASSWORD_SUCCESS',
    payload: passwords,
});

export const ResetPassword = (Opass:any,Rpass:any,Repass:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {opass:Opass,rpass:Rpass,repass:Repass,uid:uid};
            const apiname = passwordapi.resetpassword;
            const response = await LoginService.getData(apiname,payload)
            dispatch(ResetPasswordSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
